module.exports = __webpack_public_path__ + "media/images/landing/data/fidu-3d6dfdb65dc61a6ada1de63dd28f18db.png";